<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" v-hasPermi="['fina:receivable:list']" @load="onLoad" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item,index) in list" :key="index" @click="toFinaReceivableDetails(item)">
        <div class="flex-between" v-if="item">
          <div>
            <div class="custName-wrap">
              <div class="custName">
                {{ item.custName }}
              </div>
            </div>
            <div>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.phaseNum">合同编号：{{ item.contractNum }}</van-tag>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.currPaymentMoney">本次回款：{{ item.currPaymentMoney }} (元)</van-tag>
            </div>
            <div>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.currPaymentTime">回款日期：{{ item.currPaymentTime | timeFormat }}</van-tag>
            </div>
          </div>
          <van-icon name="arrow" size="16" class="arrow-color" @click="toFinaReceivableDetails(item)" />
        </div>
      </van-cell>
    </van-list>

    <!--添加线索客户-->
    <van-dialog v-model="show" title="添加订单客户" @confirm="confirm" close-on-click-overlay>
      <div class="dialog-form-wrap">
        <van-cell-group>
          <van-field v-model="form.custName" label="客户名称" />
          <van-field readonly clickable v-model="form.custLevelName" @click="showPicker('custLevelId')" label="客户等级" />
          <van-field readonly clickable v-model="form.areaName" label="地区" @click="showPicker('areaId')" />
          <van-field readonly clickable v-model="form.industryName" label="行业" @click="showPicker('industryCode')" />
          <!-- <van-field v-model="form.clueId" label="线索ID" /> -->
          <van-field readonly clickable v-model="form.custTypeName" @click="showPicker('custType')" label="客户类型" />
          <van-field readonly clickable v-model="form.custSourceName" @click="showPicker('custSource')" label="客户来源" />
          <van-field v-model="form.scale" label="企业规模" />
          <van-field v-model="form.mainProducts" label="主营产品" />
          <van-field v-model="form.distributionUserName" label="分配用户" />
          <van-field v-model="form.teamPeople" label="协作人" />
          <van-field v-model="form.website" label="企业网站" />
          <van-field v-model="form.custAddress" label="地址" />
          <van-field label="状态">
            <template #input>
              <van-radio-group v-model="form.status" direction="horizontal">
                <van-radio :name="item.dictValue" v-for="item in statusOptions" :key="item.dictValue">{{ item.dictLabel }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <!-- <van-field v-model="form.orderNum" type="number" label="排序" /> -->
          <van-field v-model="form.custProfile" label="客户简介" />
          <van-field v-model="form.remark" label="备注" />
        </van-cell-group>
      </div>
    </van-dialog>

    <!--客户搜索-->
    <search-pop :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />

    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>
  </div>
</template>

<script>
import moment from "moment";
import {
  Search,
  List,
  Cell,
  Button,
  Tag,
  Dialog,
  Area,
  Toast,
  Icon,
  Field,
  Col,
  Row,
  CellGroup,
  Popup,
  Picker,
  Radio,
  RadioGroup,
} from "vant";
import {
  listReceivable,
  getReceivable,
  delReceivable,
  addReceivable,
  updateReceivable,
  exportReceivable,
} from "@/api/fina/receivable";
import { getDicts } from "@/api/system/dict/data";
import { selectAllCustLevel } from "@/api/scrm/custlevel";
import { areaList } from "@vant/area-data";
import SearchComponent from "@/components/common/Search";
import TotalComponent from "@/components/common/Total";
import SearchPop from '../components/ReceSearchPop'
export default {
  components: {
    [Search.name]: Search,
    [List.name]: List,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    SearchComponent,
    SearchPop,
    TotalComponent
  },
  filters: {
    timeFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    },
    // washResultFormat(val) {
    //    return this.selectDictLabel(this.washResultOptions, val);
    // },
  },
  data() {
    return {
      total: null,
      picker: {
        visible: false,
        title: "",
        columns: [],
        formKey: "",
        areaList,
      },
      loading: false,
      finished: false,
      showFilterPop: false,
      list: [],
      type: "add",
      show: false,
      searchParams: {
        visible: false,
      },
      searchValue: "",
      invoiceList: [],
      // 发票类型
      invoiceTypeOptions: [],
      // 发票状态
      invoiceStatusOptions: [],
      // 状态数据字典
      statusOptions: this.$store.state.dictOptions.status || [],
      form: {
        receivableId: null,
        phaseNum: null,
        custId: null,
        custName: null,
        contractId: null,
        contractNum: null,
        contractName: null,
        contractMoney: null,
        currPaymentMoney: null,
        currPaymentTime: null,
        invoiceStatus: "0",
        openInvoiceTime: null,
        userId: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null,
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        phaseNum: null,
        custId: null,
        custName: null,
        contractId: null,
        contractNum: null,
        contractName: null,
        contractMoney: null,
        currPaymentMoney: null,
        currPaymentTime: null,
        invoiceStatus: null,
        openInvoiceTime: null,
        userId: null,
        status: null,
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      //修改主体框架标题
      document.title = "FINA-收款信息";

      //发票类型
      this.getDicts("accinvoice_invoice_type").then((response) => {
        this.invoiceTypeOptions = response.data; // string
      });
      //发票状态
      this.getDicts("accinvoice_invoice_status").then((response) => {
        this.invoiceStatusOptions = response.data; // string
      });
      //状态字段
      // getDicts("sys_normal_disable").then((response) => {
      //   this.statusOptions = response.data;
      // });
      await this.handleList();
    },
    // 获取列表数据
    queryInvoiceList() {
      this.list = [];
      this.queryParams.pageNum = 1
      this.handleList();
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      console.log('handelSearch', data);
      this.resetQuery()
      this.queryParams.custName = this.searchValue = data;
      this.queryInvoiceList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      console.log('handleFqueryFilter', data);
      let query = this.queryParams;
      this.queryParams = { ...query, ...data }
      this.queryInvoiceList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    toFinaReceivableDetails(item) {
      this.$router.push(`/receivableDetail/${item.receivableId}`);
    },
    //发票类型字典翻译
    invoiceTypeFormat2(invoiceType) {
      return this.selectDictLabel(this.invoiceTypeOptions, invoiceType);
    },
    invoiceTypeFormat(row, column) {
      return this.selectDictLabel(this.invoiceTypeOptions, row.invoiceType);
    },
    //发票类型字典翻译
    invoiceStatusFormat2(invoiceStatus) {
      return this.selectDictLabel(this.invoiceStatusOptions, invoiceStatus);
    },
    invoiceStatusFormat(row, column) {
      return this.selectDictLabel(this.invoiceStatusOptions, row.invoiceStatus);
    },
    showPicker(type) {
      this.picker.formKey = type;
      if (type === "custLevelId") {
        this.picker.columns = this.custLevelOptions.map((ele) => ele.levelName);
      }
      if (type === "custSource") {
        this.picker.columns = this.custSourceOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "custType") {
        this.picker.columns = this.custTypeOptions.map((ele) => ele.dictLabel);
      }
      if (type === "industryCode") {
        this.picker.columns = this.industryOptions.map((ele) =>
          this.industryNormalizer(ele)
        );
      }
      if (type === "areaId") {
        this.picker.columns = this.areaOptions.map((ele) =>
          this.areaNormalizer(ele)
        );
      }
      this.picker.visible = true;
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === "custLevelId") {
        this.form.custLevelId = this.custLevelOptions[index].custLevelId;
        this.form.custLevelName = this.custLevelOptions[index].levelName;
      }
      if (this.picker.formKey === "custSource") {
        this.form.custSource = this.custSourceOptions[index].dictValue;
        this.form.custSourceName = this.custSourceOptions[index].dictLabel;
      }
      this.picker.visible = false;
    },
    /** 转换行业数据结构 */
    industryNormalizer(node) {
      let arr = [];
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].systemIndustryId,
            text: node.children[i].industryName,
          };
          arr.push(item);
        }
      }

      return {
        id: node.systemIndustryId,
        text: node.industryName,
        children: arr,
      };
    },

    /** 转换地区数据结构 */
    areaNormalizer(node) {
      let arr = [];
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].areaId,
            text: node.children[i].areaName,
          };
          arr.push(item);
        }
      }

      return {
        id: node.areaId,
        text: node.areaName,
        children: arr,
      };
    },
    pickerCancel() {
      this.picker.visible = false;
    },
    pickerChange() { },
    update(type, row) {
      this.reset();
      this.type = type;
      this.show = true;
      if (row) {
      }
    },
    confirm() {
      if (this.type !== "add") {
        updateReceivable(this.form).then((response) => {
          Toast("修改成功");
          this.dialogVisible = false;
          this.handleList();
        });
      } else {
        addReceivable(this.form).then((response) => {
          Toast("新增成功");
          this.dialogVisible = false;
          this.handleList();
        });
      }
    },
    async handleList() {
      this.list = [];
      this.loading = true;
      const res = await listReceivable(this.queryParams);
      if (res.code === 200) {
        this.total = res.total;
        this.list = this.list.concat(res.rows);
        this.queryParams.pageNum += 1;
        this.loading = false;
        this.finished = this.list.length >= res.total;
        this.showFilterPop = false
      }
    },
    onLoad() {
      this.handleList();
    },
    //获取用户等级
    getCustLevelList() {
      selectAllCustLevel(null).then((response) => {
        this.custLevelOptions = response.data;
      });
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: null,
        contractStatus: null,
        payMode: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        startTime: null,
        endTime: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        status: null,
      };
    },
    reset() {
      this.form = {
        receivableId: null,
        phaseNum: null,
        custId: null,
        custName: null,
        contractId: null,
        contractNum: null,
        contractName: null,
        contractMoney: null,
        currPaymentMoney: null,
        currPaymentTime: null,
        invoiceStatus: "0",
        openInvoiceTime: null,
        userId: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null,
      };
    },
  },
};
</script>


<style scoped lang='less'>
@import url("@/style/index.less");
.type-list {
  padding: 10px;
  .title {
    font-size: 40px;
    margin-bottom: 20px;
  }
  .list-wrapper {
    display: flex;
    flex-wrap: wrap;
    button {
      margin: 10px;
    }
  }
}
.arrow-color {
  color: #eee;
}
</style>
<style>
</style>